<div class="drop-down__container" (click)="toggleOption()" role="button">
  <img [src]="imgSrc" [ngClass]="{ open: showOption }" class="icon margin-auto" alt="" />
  @if (this.showOption) {
    <div class="drop-down__main" (mouseleave)="closeDropDown()" (mouseenter)="$event.stopImmediatePropagation()">
      @if (isShowEditOption) {
        <li (click)="onAction(DROP_DOWN_ACTIONS.EDIT_CARRIER)">
          <a>Edit</a>
        </li>
      }
      @if (isShowVerificationOption) {
        <li (click)="onAction(DROP_DOWN_ACTIONS.COMPLETE_VERIFICATION)">
          <a>Complete Verification</a>
        </li>
      }
      <li (click)="onAction(DROP_DOWN_ACTIONS.DUPLICATE_CARRIER)">
        <a>Duplicate</a>
      </li>
      <li (click)="onAction(DROP_DOWN_ACTIONS.DELETE_CARRIER)">
        <a>Delete</a>
      </li>
    </div>
  }
</div>
